import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

function initTestimonialsSlider() {
    const layout = document.querySelector('.slider-layout');
    if (!layout) return;

    const slider = layout.querySelector('.slider-testimonials');

    const liveRegion = document.createElement('div');
    liveRegion.className = 'visually-hidden';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    layout.appendChild(liveRegion);

    const syncCaptions = (index) => {
        layout.querySelectorAll('.slider-caption').forEach((el, i) => {
            el.classList.toggle('is-active', i === index);
        });
    };

    const clearSwiperStyles = (swiper) => {
        swiper.wrapperEl.style.removeProperty('transform');
        swiper.wrapperEl.style.removeProperty('width');
        swiper.wrapperEl.style.removeProperty('height');
        swiper.wrapperEl.style.removeProperty('transition-duration');
        swiper.slides.forEach(slide => {
            slide.style.removeProperty('width');
            slide.style.removeProperty('margin-right');
        });
    };

    new Swiper(slider, {
        modules: [Navigation, Pagination, A11y],
        a11y: {
            enabled: true,
            firstSlideMessage: 'This is the first testimonial',
            lastSlideMessage: 'This is the last testimonial',
            nextSlideMessage: 'Next testimonial',
            prevSlideMessage: 'Previous testimonial',
        },
        grabCursor: true,
        rewind: true,
        navigation: {
            nextEl: layout.querySelector('.button-next'),
            prevEl: layout.querySelector('.button-prev'),
        },
        pagination: {
            clickable: true,
            el: layout.querySelector('.swiper-pagination'),
        },
        on: {
            init() {
                clearSwiperStyles(this);
                syncCaptions(this.activeIndex);
            },
            resize() {
                requestAnimationFrame(() => clearSwiperStyles(this));
            },
            slideChange() {
                clearSwiperStyles(this);
                liveRegion.textContent = `Slide ${this.activeIndex + 1} of ${this.slides.length}`;
                syncCaptions(this.activeIndex);
            },
        },
    });
}

document.addEventListener('DOMContentLoaded', initTestimonialsSlider);
